import api from '@functions/api'

import { handleError } from '@redux/utils'

import type { EntityOptions } from '@redux/modules/module'

type Config = {
  method?: 'DELETE' | 'POST' | 'PUT',
  body?: string,
  withCredentials?: boolean,
}

const callApi = <Data>(endpoint: string, options: EntityOptions = {}, config: Config = {}) => {
  const promise = api(`${endpoint}.json`, options, config)
    .then(({ data }: { data: Data }) => ({ success: true as const, data }))
    .catch((data) => {
      const errors = handleError(data)

      return { success: false as const, errors }
    })

  return promise
}

export default callApi
